import adminApi from '@/services/adminApi';
import * as types from './mutations-types';

/**
 * Listar todos os usuários
 */
export const ActionGetUsers = ({ commit }, filters) => {
    return adminApi.listUsers(filters).then(response => {
        // Backend pode retornar { data: [...] } ou diretamente [...]
        const users = Array.isArray(response.data) ? response.data : (response.data.data || []);
        commit(types.SET_USERS, users);
        return users;
    });
};

/**
 * Listar serviços
 */
export const ActionGetServices = ({ commit }) => {
    return adminApi.listServices().then(response => {
        const services = Array.isArray(response.data) ? response.data : (response.data.data || []);
        commit(types.SET_SERVICES, services);
        return services;
    });
};

/**
 * Criar novo usuário
 */
export const ActionCreateUser = ({ commit }, userData) => {
    return adminApi.createUser(userData).then(response => {
        const newUser = response.data.data || response.data;
        commit(types.ADD_USER, newUser);
        return newUser;
    });
};

/**
 * Editar usuário
 */
export const ActionUpdateUser = ({ commit }, { userId, userData }) => {
    return adminApi.updateUser(userId, userData).then(response => {
        const updatedUser = response.data.data || response.data;
        commit(types.UPDATE_USER, updatedUser);
        return updatedUser;
    });
};

/**
 * Inativar usuário
 */
export const ActionDeleteUser = ({ commit }, userId) => {
    return adminApi.deleteUser(userId).then(response => {
        commit(types.DELETE_USER, userId);
        return response.data;
    });
};

/**
 * Conceder acesso a um plano (Starter ou Premium)
 */
export const ActionGrantPro = ({ commit }, { userId, expiresAt, notifyUser, profileSlug = 'pro' }) => {
    return adminApi.grantPro(userId, expiresAt, notifyUser, profileSlug).then(response => {
        // Atualizar usuário na lista
        if (response.data.user) {
            commit(types.UPDATE_USER, response.data.user);
        }
        return response.data;
    });
};

/**
 * Estender prazo de acesso Pro
 */
export const ActionExtendPro = ({ commit }, { userId, newExpiresAt }) => {
    return adminApi.extendPro(userId, newExpiresAt).then(response => {
        // Atualizar usuário na lista
        if (response.data.user) {
            commit(types.UPDATE_USER, response.data.user);
        }
        return response.data;
    });
};

/**
 * Tornar acesso Pro permanente
 */
export const ActionMakeProPermanent = ({ commit }, userId) => {
    return adminApi.makeProPermanent(userId).then(response => {
        // Atualizar usuário na lista
        if (response.data.user) {
            commit(types.UPDATE_USER, response.data.user);
        }
        return response.data;
    });
};

/**
 * Revogar acesso Pro
 */
export const ActionRevokePro = ({ commit }, userId) => {
    return adminApi.revokePro(userId).then(response => {
        // Atualizar usuário na lista
        if (response.data.user) {
            commit(types.UPDATE_USER, response.data.user);
        }
        return response.data;
    });
};
